import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree, Router } from '@angular/router';
import { filter, Observable, take } from 'rxjs';
import { Store } from '@ngxs/store';
import { map } from 'rxjs/operators';
import { IUser } from '../interfaces/IUser';
import { UserState } from '../states/user.state';

@Injectable({
  providedIn: 'root',
})
export class ContractTypeGuard {
  private router = inject(Router);
  private store = inject(Store);
  private user$: Observable<IUser> = this.store.select<IUser>(UserState.user);

  canActivate(next: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | boolean {
    const allowedContractTypes: string[] = next.data.contractTypes;
    if (!allowedContractTypes || !allowedContractTypes.length) {
      return true;
    }

    return this.user$.pipe(
      filter((user: IUser) => !!user.gid),
      take(1),
      map((user: IUser) => {
        if (user.isTimekeeper || allowedContractTypes.includes(user.contractTypeName)) {
          return true;
        }
        return this.router.createUrlTree(['/home']);
      }),
    );
  }
}
